module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-3-Australia-Landing-Page-w720.92aa6a9d.webp";